export default __webpack_public_path__ + "static/media/tips-person.cf2f0fb3.svg";